import {SecureService} from "@/services/superclasses/secure-service";
import {MemberManage} from "@/interfaces/member-manage";
import {FormResponse} from "@/interfaces/form-response";
import {Member} from "@/interfaces/member";

const api = window.contextPath + '/rest/members';

export class MemberSecureService extends SecureService {

    public update = async (data: MemberManage): Promise<FormResponse<MemberManage>> => {
        return this.data(await this.put<FormResponse<MemberManage>>(api, data))
    }

    public manage = async (): Promise<MemberManage> => {
        return this.data(await this.get<MemberManage>(api))
    };

    public loadByPerson = async (): Promise<Member> => {
        return this.data(await this.get<Member>(`${api}/by-person`))
    };
}

export const memberSecureService = new MemberSecureService()